import { filterWeeksOnDestinationByCompany } from '../helpers/week';
import { COMPANIES } from '../constants';

const initialState = {
  items: []
};

const destinations = (state = initialState, action) => {
  switch (action.type) {
  case 'FETCH_DESTINATIONS': {
    const companyDestinations = action.destinations
      .map(d => ({ ...d, weeks: filterWeeksOnDestinationByCompany(d, action.companyId || COMPANIES.DAY8) }))
      .filter(d => d.weeks.length);
    return {
      ...state,
      items: companyDestinations
    };
  }
  default:
    return state;
  }
};

export default destinations;
